/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { FaStar } from 'react-icons/fa';
import axios from 'axios';

/**
 * JobCardReviewIndicator - Shows customer review rating in job cards
 * 
 * Props:
 * - job: object - the job object containing customer info
 * - onReviewsClick: function - called when star is clicked with review data
 * - size: string - size of the star ('sm', 'md', 'lg')
 */
export default function JobCardReviewIndicator({ job, onReviewsClick, size = 'sm' }) {
  const [reviewData, setReviewData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (job && job.customerPhone) {
      checkCustomerReviews();
    }
  }, [job?.customerPhone]);

  const checkCustomerReviews = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      params.append('phone', job.customerPhone);

      const response = await axios.get(`/view-leads/customer-reviews/check?${params}`);
      setReviewData(response.data);
    } catch (error) {
      console.error('Error checking customer reviews:', error);
      setReviewData(null);
    } finally {
      setLoading(false);
    }
  };

  const handleStarClick = (e) => {
    e.stopPropagation(); // Prevent job card click
    if (reviewData && reviewData.hasReviews && onReviewsClick) {
      onReviewsClick(reviewData, job);
    }
  };

  // Don't render if no reviews or still loading
  if (loading || !reviewData || !reviewData.hasReviews) {
    return null;
  }

  const starSize = size === 'sm' ? 14 : size === 'md' ? 16 : 18;
  const fontSize = size === 'sm' ? '0.75rem' : size === 'md' ? '0.8rem' : '0.9rem';

  return (
    <span 
      className="d-inline-flex align-items-center ms-1"
      style={{ cursor: 'pointer' }}
      onClick={handleStarClick}
      title={`${job.customerName} has ${reviewData.totalReviews} review(s) - Average: ${reviewData.averageRating}/5 stars`}
    >
      <FaStar 
        size={starSize} 
        color="#ffc107" 
        style={{ 
          filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.3))',
          animation: 'pulse 2s infinite'
        }}
      />
      <span 
        className="ms-1 fw-bold text-warning"
        style={{ 
          fontSize: fontSize,
          textShadow: '0 1px 2px rgba(0,0,0,0.3)'
        }}
      >
        {reviewData.averageRating}
      </span>
      <style jsx>{`
        @keyframes pulse {
          0%, 100% { 
            transform: scale(1);
            opacity: 1;
          }
          50% { 
            transform: scale(1.1);
            opacity: 0.8;
          }
        }
      `}</style>
    </span>
  );
}
